module.exports = __webpack_public_path__ + "static/img/12areaA_05.5de11d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/12areaA_05.png
// module id = 789
// module chunks = 1